<template>
  <modal :fullscreen="true" :show="show" @close="close">
    <v-flex slot="title">{{ !!id ? 'Edytuj szablon' : 'Dodaj szablon' }}</v-flex>

    <div>
      <v-layout column>
        <v-flex xs12>
          <w-schema :model="$schema.name">
            <v-text-field name="name" label="Nazwa szablonu*"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex md12>
          <v-layout row wrap>
            <v-flex pr-2 xs12 md6>
              <w-schema :model="$schema.fromName">
                <v-text-field name="fromName" label="Nazwa nadawcy*"></v-text-field>
              </w-schema>
            </v-flex>

            <v-flex pl-2 xs12 md6>
              <w-schema :model="$schema.fromAddress">
                <v-text-field name="fromAddress" label="E-mail nadawcy*"></v-text-field>
              </w-schema>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.to">
            <v-text-field name="to" label="Odbiorca"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex xs12>
          <w-schema :model="$schema.subject">
            <v-text-field name="subject" label="Temat*"></v-text-field>
          </w-schema>
        </v-flex>

        <v-flex class="mb-4">
          <html-editor :schema="$schema.body" :code-editor="true"></html-editor>
        </v-flex>
      </v-layout>

      <span class="caption grey--text">*oznaczone pola są wymagane</span>
    </div>

    <v-layout slot="actions">
      <v-spacer></v-spacer>

      <v-btn color="error" flat @click="close">Anuluj</v-btn>

      <v-btn color="success" flat @click="save">Zapisz</v-btn>
    </v-layout>
  </modal>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';
import { ProfileType } from '@witkac/kartamiejska-shared';

import schema from '@/schemas/mailTemplate.schema';
import modal from '@/components/material/Modal';
import { manageMixin } from '@/mixins/manage';
import HtmlEditor from '@/components/forms/HtmlEditor';

const emptyData = () => ({
  name: '',
  subject: '',
  fromName: '',
  fromAddress: '',
  to: '',
  body: ''
});

export default {
  components: { modal, HtmlEditor, WSchema },
  mixins: [manageMixin('mailTemplates', {}, emptyData)],
  schema
};
</script>
